module.exports = __webpack_public_path__ + "static/media/arrow-down-filled.1c18832d.svg";